import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import { tableData} from './data'
import './index.scss'
import {Button, message, Modal} from 'antd'
import {getReginster,shepi} from "../../../servers/province";
import {withRouter} from "react-router-dom";
import CSelect from '@/components/CForm/CSelect'
import CInput from "../../../components/CForm/CInput";
import {selectPicDetail} from "../../../servers/menu";


@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.editHandler = this.editHandler.bind(this);
    this.modalCancel = this.modalCancel.bind(this);
    this.shepiHandler = this.shepiHandler.bind(this)
    this.inputChange = this.inputChange.bind(this)
    this.onChange = this.onChange.bind(this)
    this.downloads = this.downloads.bind(this)
    this.modalCancel1 = this.modalCancel1.bind(this);
    this.handlePreview = this.handlePreview.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    page: tableData.tPage,
    loading: true,
    socialcode:'',
    modal: {
      title: '博物馆申报注册审核',
      visible: false,
    },
    reasonlist:[],
    reason:'',
    editdata:{},
    previewVisible:false,
    previewImage:''
  };

  inputChange(value){
    this.setState({
      socialcode:value
    })
  }

  onChange(value){
    console.log(value);
    this.setState({
      reason:value
    })
  }
  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    getReginster().then(res=>{
      if (res.records.length>0){
        let data =JSON.parse(JSON.stringify(res.records))
        let total = 1;
        this.setState({
          dataSource: data,
          page: {...this.state.page, total},
          loading: false,
        });
      } else {
        this.setState({
          loading: false
        });
      }

    }).catch(err=>{
      console.log(err,'rttt')
    })
  }


  modalCancel(){
    this.setState({
      modal: {...this.state.modal, visible: false},
      socialcode:''
    })
  }
  // 编辑当前行
  editHandler(data){
    let reasons = []
    if (data.reason && data.reason.length > 0) {
      data.reason.forEach(item=>{
        reasons.push({
          value:item,
          id:item,
          name:item
        })
      })
    }
    this.setState({
      modal: {...this.state.modal, visible: true},
      editdata:data,
      socialcode:data.socialcode,
      reasonlist:reasons,
      reason:reasons.length>0?reasons[0].value:''
    });
  }
  shepiHandler(data){
    const params = {
      id:this.state.editdata.id,
      action:data,
      socialcode:this.state.socialcode,
      reason: data === 'y'?'':this.state.reason
    }
    shepi(params).then(res=>{
      if (res.statecode === 0) {
        const m = data === 'y' ?'审批成功' : '驳回成功'
        message.success(m)
        this.setState({
          modal: {...this.state.modal, visible: false},
        });
        this.getListData()
      } else {
        message.error(res.statemessage)
      }
    })
  }

  // 点击modal打开
  async handlePreview(file){
    const params = {
      fileid: file.fileid
    }
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].filepreviewurl !== '' && res.records[0].filepreviewurl !== null) {
        window.open(res.records[0].filepreviewurl, '_blank')
      }
    })
  }

  downloads(file){
    const params = {
      fileid: file.fileid
    }
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].fileurl !== '' && res.records[0].fileurl !== null) {
        window.location.href = res.records[0].fileurl
      } else {
        message.error('查询失败')
      }
    })
  }

  modalCancel1(){
    this.setState({
      previewVisible: false
    })
  }

  componentDidMount(){
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} onTableChange={this.onTableChange}>
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      {
                        record.status === '待审核' ? <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>审核</CButton>:
                            <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>查看</CButton>
                      }
                    </div>
                )} />
          </CTable>
          <Modal
              title={this.state.modal.title}
              visible={this.state.modal.visible}
              onCancel={this.modalCancel}
              footer={null}
          >
            <div className='shenhe-block'>
              <div className='shenhe-item'>
                  <span>统一社会信用代码：</span>
                  <CInput value={this.state.socialcode} disabled={this.state.editdata.status !=='待审核'} style={{width:'200px'}} onChange={(value)=>{this.inputChange(value)}}/>
                  <span style={{marginLeft:'10px'}}>{this.state.socialcode.length}位</span>
              </div>
              <div className='shenhe-item'>
                <span>年报统一社会信用代码：</span>
                <span style={{marginLeft: '12px', fontSize: '13px'}}>{this.state.editdata.arsocialcode}</span>
              </div>
              <div className='shenhe-item'>
                <span>所处省份：</span>
                <span>{this.state.editdata.province}</span>
              </div>
              <div className='shenhe-item'>
                <span>所处地区：</span>
                <span>{this.state.editdata.region}</span>
              </div>
              <div className='shenhe-item'>
                <span>博物馆名称：</span>
                <span>{this.state.editdata.name}</span>
              </div>
              <div className='shenhe-item'>
                <span>博物馆性质：</span>
                <span>{this.state.editdata.nature}</span>
              </div>
              <div className='shenhe-item'>
                <span>博物馆当前等级： </span>
                <span>{this.state.editdata.level}</span>
              </div>
              <div className='shenhe-item'>
                <span>申请等级： </span>
                <span>{this.state.editdata.applylevel}</span>
              </div>
              <div className='shenhe-item'>
                <span>举办者： </span>
                <span>{this.state.editdata.holder}</span>
              </div>
              <div className='shenhe-item'>
                <span>管理员姓名： </span>
                <span>{this.state.editdata.adminname}</span>
              </div>
              <div className='shenhe-item'>
                <span>管理员手机号码： </span>
                <span>{this.state.editdata.adminphone}</span>
              </div>
              {this.state.editdata.files && this.state.editdata.files.length > 0 &&
                  <div className='shenhe-item'>
                    <span>相关证明资料： </span>
                    <span>
                  { this.state.editdata.files.map(item2=>{
                    return <div className='file-blocks'>
                      <div className='file-name'>
                        {item2.filename}
                      </div>
                      <div className='file-operate'>
                        <Button type="link" onClick={()=>{this.handlePreview(item2)}}>预览</Button>
                        <Button type="link" onClick={()=>{this.downloads(item2)}} style={{marginLeft:'-20px'}}>下载</Button>
                      </div>
                    </div>
                  })}
                </span>
                  </div>
              }
              {this.state.reasonlist.length>0 && this.state.editdata.status ==='待审核' &&
              <div>
                <div style={{height:'2px',width:'100%',margin:'20px 0',background:'#bebebe'}}></div>
                <div className='shenhe-item'>
                  <span>驳回理由： </span>
                  <CSelect
                      value={this.state.reason}
                      options={this.state.reasonlist}
                      onChange={(value)=>{this.onChange(value)}}
                      style={{width:'300px'}}
                  />
                </div>
              </div>
              }
            </div>
            {this.state.editdata.status ==='待审核' &&  <div className='operate-btn'>
              <CButton type='primary' onClick={() => this.shepiHandler('y')}>通过</CButton>
              <CButton type='error' danger onClick={() => this.shepiHandler('n')} style={{marginLeft:'20px'}}>驳回</CButton>
            </div>
            }
          </Modal>
          <Modal visible={this.state.previewVisible} footer={null} onCancel={this.modalCancel1}>
            <div style={{width:'100%',height:'400px',display:'flex',justifyContent:'center',alignItems:'center'}}>
              <img alt="example" style={{ maxWidth: '400px' }} src={this.state.previewImage} />
            </div>
          </Modal>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
